import WithdrawApi from 'api/withdraw'

// actions
const actions = {
  // get list of withdraws
  index(state) {
    return WithdrawApi.index()
  }
}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/withdraw.js